<template>
  <div id="navbar">
    <div class="navbar-container">
      <div class="navbar-box pt-4">
        <div>
          <router-link to="/" class="text-dark navbar-item">
            <i class="far fa-home"></i>
            <p class="navbar-item-text">
              Home
            </p>
          </router-link>
        </div>
        <div>
          <router-link to="/card" class="text-dark navbar-item">
            <i class="far fa-coffee"></i>
            <p class="navbar-item-text">
              Jouer
            </p>
          </router-link>
        </div>
        <div>
          <router-link to="/proposer-une-question" class="text-dark navbar-item">
            <i class="far fa-comment-alt-plus"></i>
            <p class="navbar-item-text">
              Proposer
            </p>
          </router-link>
        </div>
        <div>
          <router-link to="/rules" class="text-dark navbar-item">
            <i class="fad fa-scroll-old"></i>
            <p class="navbar-item-text">
              Règles
            </p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'navbar',
  data () {
    return {
      toggle: true
    }
  },
  methods: {}
}
</script>

<style>

.navbar-container {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 55px;
  border-top: 1px solid #ebebeb;
  border-radius: 40px 40px 0 0;
  background-color: #fff;
  box-shadow: 10px 4px 14px 0 rgba(0,0,0,.2);
  z-index: 4;
}
.navbar-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80vw;
  height: 100%;
  margin: 0 auto;
  text-align: center;
}
.navbar-item {
  display: flex;
  flex-direction: column;
}
.navbar-item-text {
  font-size: 13px;
}
.navbar-img-anim {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/NavbarComponent.vue